import { LargeVisionActionsTypes } from './types'

const ActionTypes: LargeVisionActionsTypes = {
    DASHBOARD_LARGEVISION_DEVICES_ONLINE: {
        request: 'DASHBOARD_LARGEVISION_DEVICES_ONLINE##REQUEST',
        success: 'DASHBOARD_LARGEVISION_DEVICES_ONLINE##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_DEVICES_ONLINE##FAILURE',
    },
    DASHBOARD_LARGEVISION_DWELLTIMELINE: {
        request: 'DASHBOARD_LARGEVISION_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_LARGEVISION_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST: {
        request: 'DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST##REQUEST',
        success: 'DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_INTERACTIONS_PLAYLIST##FAILURE',
    },
    DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT: {
        request: 'DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT##REQUEST',
        success: 'DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT##FAILURE',
    },
    DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS: {
        request: 'DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS##REQUEST',
        success: 'DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_INTERACTIONS_TOTALS##FAILURE',
    },
    DASHBOARD_LARGEVISION_PLAYLIST_TOP: {
        request: 'DASHBOARD_LARGEVISION_PLAYLIST_TOP##REQUEST',
        success: 'DASHBOARD_LARGEVISION_PLAYLIST_TOP##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_PLAYLIST_TOP##FAILURE',
    },
    DASHBOARD_LARGEVISION_SESSIONSTIMELINE: {
        request: 'DASHBOARD_LARGEVISION_SESSIONSTIMELINE##REQUEST',
        success: 'DASHBOARD_LARGEVISION_SESSIONSTIMELINE##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_SESSIONSTIMELINE##FAILURE',
    },
    DASHBOARD_LARGEVISION_STORES_TOP: {
        request: 'DASHBOARD_LARGEVISION_STORES_TOP##REQUEST',
        success: 'DASHBOARD_LARGEVISION_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_LARGEVISION_STORES_TOP##FAILURE',
    },
}

export default ActionTypes
